import React, { ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Row, Col } from 'reactstrap';
import Gallery from 'react-photo-gallery';
import { tabResultState } from '../../../modules/tabResult';

const KnowledgeGraphComponent = styled.div`
  margin-top: 24px;
  width: 100%;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
`;

const KnowledgeGraphImageContent = styled.div`
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
`;

const KnowledgeGraphTextContent = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

const KnowledgeGraphTitleBox = styled.div`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 10px;
`;

const KnowledgeGraphDescBox = styled.div`
  font-size: 14px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #222222;
`;

const KnowledgeGraphSourceBox = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #999999;
  margin-bottom: 20px;
`;

const KnowledgeGraphSubBox = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const KnowledgeGraphSubTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  margin-right: 6px;
`;

const KnowledgeGraphKindsText = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #222222;
`;
const KnowledgeGraphKindsTitle = styled.div``;

const Data = {
  title: '정책',
  desc:
    '결정 사항을 안내하고 합리적인 결과를 수행할 수 있게 하는 원칙이나 규율을 가리킨다. 사전적 의미로는 정치나 정무를 시행하는 방침이다.',
  source: 'Wikipedia',
  kinds: ['인적 자원 정책', '개인 정보 정책', '공공정책'],
  link: ['(영어) Policy institutes - Curlie', 'www.naver.com'],
};

const photos = [
  {
    src: 'https://source.unsplash.com/2ShvY8Lf6l0/800x599',
    width: 4,
    height: 3,
    alt: '1',
  },
  {
    src: 'https://source.unsplash.com/Dm-qxdynoEc/800x799',
    width: 1,
    height: 1,
    alt: '2',
  },
];

type KnowledgeGraphProps = {
  wikiData: tabResultState['wikiData'];
};

class KnowledgeGraph extends React.PureComponent<KnowledgeGraphProps, any> {
  render() {
    const { wikiData } = this.props;
    return (
      <KnowledgeGraphComponent>
        {/* <KnowledgeGraphImageContent>
          <Gallery
            photos={photos}
            targetRowHeight={130}
            limitNodeSearch={10}
            margin={0}
          />
        </KnowledgeGraphImageContent> */}
        <KnowledgeGraphTextContent>
          {wikiData ? (
            <>
              <KnowledgeGraphTitleBox>
                {wikiData.wiki_title}
              </KnowledgeGraphTitleBox>
              <KnowledgeGraphDescBox>
                {wikiData.wiki_desc}
              </KnowledgeGraphDescBox>
              <KnowledgeGraphSourceBox>Wikipedia</KnowledgeGraphSourceBox>
            </>
          ) : null}

          {/* <KnowledgeGraphSubBox>
            <KnowledgeGraphSubTitle>종류</KnowledgeGraphSubTitle>
            <KnowledgeGraphKindsText>{Data.kinds}</KnowledgeGraphKindsText>
          </KnowledgeGraphSubBox>
          <KnowledgeGraphSubBox>
            <KnowledgeGraphSubTitle>외부링크</KnowledgeGraphSubTitle>
            <KnowledgeGraphKindsText>{Data.link[0]}</KnowledgeGraphKindsText>
          </KnowledgeGraphSubBox> */}
        </KnowledgeGraphTextContent>
      </KnowledgeGraphComponent>
    );
  }
}

export default KnowledgeGraph;
